var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-icon-text",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('member-icon',{attrs:{"grade":_vm.grade}}),_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.$t(`grade.${_vm.grade}`)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }